module.exports = __webpack_public_path__ + "static/media/onesystemstech-logo.d5f810f4.png";